import { useQuery } from '@tanstack/react-query';
import { getReqUrl, handleDataPlatformError } from './utils';
import dataPlatformFetch from '../../utils/dataPlatformFetch';

export const USERS_ENDPOINT = `${process.env.REACT_APP_API_HOST}:${process.env.REACT_APP_API_PORT}/v1/users`;

export const useActiveUser = ({ recaptchaToken, isEnabled }) => {
  const url = getReqUrl(USERS_ENDPOINT, '/me');
  return useQuery(
    ['fetch-active-user'],
    async () => {
      const res = await dataPlatformFetch(url, {
        method: 'GET',
        recaptchaToken
      });
      if (!res.ok) {
        await handleDataPlatformError(res);
      }
      return res.json();
    },
    { enabled: isEnabled && !!recaptchaToken }
  );
};
